<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import StreamPlayer from '@/components/ui/StreamPlayer.vue'
import CountDown from '@/components/ui/CountDown.vue'
import Spinner from '@/components/ui/Spinner.vue'
import { buildStreamPreviewSpecs } from '@/Utils/previewHost'

const props = defineProps({
	mediaPulse: {
		type: Object,
		default: null,
	},
})

const store = useStore()

const playout = computed(() => store.getters['Streams/tvPlayout'])
const playoutStartTime = computed(() => store.getters['Playout/playoutStartTime'])
const shouldShowCounter = computed(() => store.getters['Playout/shouldShowCounter'])

const streamPreviewSpecs = computed(() =>
	buildStreamPreviewSpecs(props.mediaPulse, playout.value?.key, playout.value)
)

const countdownSecsLeft = computed(() => {
	const value = playoutStartTime.value - Date.now()
	return Math.max(value, 0)
})
</script>

<template>
	<div v-if="playout?.enabled" class="w-full h-full">
		<StreamPlayer
			v-if="props.mediaPulse?.alive && streamPreviewSpecs.url"
			:stream="playout"
			:stream-url="streamPreviewSpecs.url"
			:media-pulse="mediaPulse"
			class="relative bg-black w-full h-full [&>.player-container]:h-full"
		/>
		<div
			v-else
			class="w-full h-full flex flex-col items-center justify-center text-tiny text-surface-7 bg-black"
		>
			<div v-if="!shouldShowCounter" class="text-center">
				<p class="m-0">No content in schedule</p>
				<p class="m-0 mt-1">Add items to see preview</p>
			</div>
			<div class="text-center" v-else-if="countdownSecsLeft > 0 && mediaPulse">
				TV Playout will go Live in <br />
				<CountDown class="text-tiny" :endDate="playoutStartTime" />
			</div>
			<div v-else class="w-full h-full flex items-center justify-center">
				<Spinner
					text="Retrieving data..."
					classes="text-dark-4"
					spinner-color="var(--c-dark-8)"
					spinner-size="15px"
				/>
			</div>
		</div>
	</div>
	<div
		v-else
		class="w-full h-full flex flex-col items-center justify-center bg-black rounded-md"
	>
		<p class="text-center text-sm text-dark-7 font-medium m-0">Disabled Stream</p>
		<p class="text-center text-tiny text-dark-5 mt-1 mb-0">Please enable</p>
	</div>
</template>

<style scoped></style>
